/**
 * Type of third party (customer or supplier)
 */
export enum ThirdType {
  SUPPLIER = 'supplier',
  CUSTOMER = 'customer'
}

/**
 * Represents a third party (customer or supplier)
 */
export interface Third {
  /** Third party identifier */
  id: number;
  /** Third party name */
  name: string;
  /** Third party account code */
  account: string;
  /** Expense account (for suppliers) */
  expens_account?: string | null;
  /** Income account (for customers) */
  income_account?: string | null;
  /** Type of third party (customer or supplier) */
  third_type?: ThirdType;
}
